// ##### 24-10-18 Komarov
import moment from 'moment';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';

import 'moment/locale/uk';

// ##### 23-09-14 Komarov
// import './HotelItemsCSS.css'
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import HotelRatesContent from './HotelRatesContent';
// ##### Komarov 2025-07-14
import { useSelector } from 'react-redux';

// ##### 23-02-17 Komarov: Убрал свойство "key", - оно не использовалось, и вызывало предупреждение в Консоли разработчика
// ##### Komarov 2025-07-13
const HotelRates = ({ hotelPrice, id }) => {
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);

  // ##### 24-10-18 Komarov
  return (
    <div style={{ gridColumn: '2', gridRow: '2' }} data-component="HotelRates">
      {/* ##### 23-11-02 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <HotelRatesContent
          gridAutoRows="minmax(40px, auto)"
          hotelPrice={hotelPrice}
          // ##### 25-04-21 Komarov
          id={id} // hotel's id
        />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <HotelRatesContent
          gridAutoRows="minmax(15px, auto)"
          hotelPrice={hotelPrice}
          // ##### 25-04-21 Komarov
          id={id} // hotel's id
        />
      </Media>
    </div>
  );
};

export default HotelRates;
